// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function CoinsIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M23 11.196V10.5C23 7.365 18.271 5 12 5S1 7.365 1 10.5v5c0 2.611 3.281 4.686 8 5.308v.692c0 3.135 4.729 5.5 11 5.5s11-2.365 11-5.5v-5c0-2.588-3.177-4.665-8-5.304Zm6 5.304c0 1.652-3.849 3.5-9 3.5-.466 0-.929-.016-1.385-.046C21.311 18.97 23 17.375 23 15.5v-2.283c3.734.557 6 2.067 6 3.283ZM9 18.781v-2.973c.995.13 1.997.193 3 .192a22.973 22.973 0 0 0 3-.193v2.974c-.993.147-1.996.22-3 .219a20.366 20.366 0 0 1-3-.219Zm12-5.04V15.5c0 1.049-1.551 2.175-4 2.859v-2.922c1.614-.39 2.98-.973 4-1.696ZM12 7c5.151 0 9 1.848 9 3.5S17.151 14 12 14s-9-1.848-9-3.5S6.849 7 12 7Zm-9 8.5v-1.759c1.02.723 2.386 1.305 4 1.697v2.92c-2.449-.683-4-1.81-4-2.858Zm8 6v-.521a24.068 24.068 0 0 0 2.424-.023 15.23 15.23 0 0 0 1.576.47v2.933c-2.449-.684-4-1.81-4-2.859Zm6 3.281V21.8a22.973 22.973 0 0 0 6 .008v2.973c-1.99.292-4.01.292-6 0Zm8-.422v-2.922c1.614-.39 2.98-.973 4-1.696V21.5c0 1.049-1.551 2.175-4 2.859Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
